import { filter, map, mergeMap, take } from 'rxjs/operators';
import { RootEpic } from '../../../store';
import { getErrorMessage } from '../../../utils';
import { enqueueSnackbar, initialize, pricePrgError } from './uiSlices';
import { from } from 'rxjs';
import { startSignalrHubs } from '../../../common/signalr/signalrActions';
import { fetchContacts } from '../../contacts/redux/contactsSlices';
import { fetchExternalPricelists } from '../../externalpricelist/redux/externalPricelistSlices';
import { fetchPricelists } from '../../pricelist/redux/pricelistSlices';
import { fetchProducts, fetchProductCategories, fetchProductGroups } from '../../product/redux/productSlices';
import {
    fetchUserSettings,
    fetchAppSettings,
    getApplicationRestrictions
} from '../../settings/redux/settingsSlices';
import { fetchWarehouses } from '../../stock/redux/stockSlices';
import { fetchCurrentUserPermissions } from '../../user/redux/userSlices';
import { fetchExchangeRates } from '../../exchangerates/redux/exchangeRateSlices';

const pricePrgError$: RootEpic = action$ =>
    action$.pipe(
        filter(pricePrgError.match),
        map(error => {
            console.error(error.payload);
            return enqueueSnackbar({
                message: getErrorMessage(error.payload),
                severity: 'error',
                autoHideDuration: 30000
            });
        })
    );

// Initializes the app with data. Starting signalr hubs, fetching base data.
// Should only be done once, hence the take(1)
const initialize$: RootEpic = action$ =>
    action$.pipe(
        filter(initialize.match),
        take(1),
        mergeMap(() =>
            from([
                // Only dispatch init actions which doesn't require any
                // specific policy to fetch here.
                // Guarded actions should be fetched inside userEpics
                // after receiving the current user permission response.
                startSignalrHubs(),
                fetchCurrentUserPermissions.request(null),
                fetchProducts.request(),
                fetchProductCategories.request(),
                fetchProductGroups.request(),
                fetchPricelists.request(),
                fetchUserSettings.request(),
                fetchExternalPricelists.request(),
                fetchWarehouses.request(),
                fetchAppSettings.request(),
                fetchContacts.request(),
                getApplicationRestrictions.request(),
                fetchExchangeRates.request()
            ])
        )
    );

export default [pricePrgError$, initialize$];
